module.exports = __webpack_public_path__ + "static/bioImage-bf87db579a78dbbb582a33abc8148a02.jpg";